import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { CallbackComponent } from './features/auth/callback/callback.component';
import { InitComponent } from './features/auth/init/init.component';
import { LinkLoginComponent } from './features/auth/link-login/link-login.component';
import { HomeComponent } from './features/home/home.component';
import { AreaOfInterestComponent } from './features/profile/area-of-interest/area-of-interest.component';
import { EditBasicProfileComponent } from './features/profile/edit-basic-profile/edit-basic-profile.component';
import { SelectTicketComponent } from "./features/ticket-booking/select-ticket/select-ticket.component";
import { TicketSummaryComponent } from "./features/ticket-booking/ticket-summary/ticket-summary.component";
import { AssignTicketComponent } from "./features/tickets/assign-ticket/assign-ticket.component";
import { TicketDetailsComponent } from './features/tickets/ticket-details/ticket-details.component';
import { TicketListComponent } from './features/tickets/ticket-list/ticket-list.component';
import { PhotoUploadComponent } from './features/tickets/photo-upload/photo-upload.component';
import { PavilionListComponent } from './features/digital-catalogue/pavilion-list/pavilion-list.component';
import { CatalogueProductListComponent } from './features/digital-catalogue/catalogue-product-list/catalogue-product-list.component';
import { CatalogueCompaniesListComponent } from './features/digital-catalogue/catalogue-companies-list/catalogue-companies-list.component';
import { CatalogueProductDetailsComponent } from './features/digital-catalogue/catalogue-product-details/catalogue-product-details.component';
import { VirtualEventComponent } from './features/virtual-event/virtual-event.component';
import { InviteDetailsComponent } from './features/exh-invite/invite-details/invite-details.component';
import { InviteListComponent } from './features/exh-invite/invite-list/invite-list.component';
import { PromotionMarathiComponent } from './features/promotion/promotion-marathi/promotion-marathi.component';
import { CatalogueCompanyDetailsComponent } from './features/digital-catalogue/catalogue-company-details/catalogue-company-details.component';
import { CatalogueProductWishlistComponent } from './features/digital-catalogue/catalogue-product-wishlist/catalogue-product-wishlist.component';
import { CatalogueCompanyWishlistComponent } from './features/digital-catalogue/catalogue-company-wishlist/catalogue-company-wishlist.component';
import { PromotionEnglishComponent } from './features/promotion/promotion-english/promotion-english.component';
import { ParticipantsListComponent } from './features/visitor-voting/participants-list/participants-list.component';
import { VideoDetailsComponent } from './features/visitor-voting/video-details/video-details.component';
import { PaymentSuccessComponent } from './features/ticket-booking/payment-success/payment-success.component';


// import { PaymentSuccessComponent } from "./shared/components/payment-success/payment-success.component";

export const routes: Route[] = [
  { path: "", component: HomeComponent },
  {
    path: "home",
    component: HomeComponent,
  },

  {
    path: "reg/select-ticket",
    component: SelectTicketComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/ticket-summary",
    component: TicketSummaryComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/assign-ticket",
    component: AssignTicketComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/ticket-details",
    component: TicketDetailsComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/edit-basic-profile",
    component: EditBasicProfileComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/my-tickets",
    component: TicketListComponent,
    canActivate: [authGuard],
  },
  {
    path: "catalogue/pavilion-list",
    component: PavilionListComponent
  },
  {
    path: "catalogue/products-list",
    component: CatalogueProductListComponent,
  },
  {
    path: "catalogue/companies-list",
    component: CatalogueCompaniesListComponent,
  },
  {
    path: "catalogue/product-details/:product_id",
    component: CatalogueProductDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: "catalogue/company-details",
    component: CatalogueCompanyDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: "exh-invite/details",
    component: InviteDetailsComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/virtual-event",
    component: VirtualEventComponent,
    canActivate: [authGuard],
  },
  {
    path: "reg/area-of-interest",
    component: AreaOfInterestComponent,
  },
  {
    path: "exh-invite/list",
    component: InviteListComponent,
    canActivate: [authGuard],
  },

  {
    path: "reg/upload-photo",
    component : PhotoUploadComponent,
    canActivate: [authGuard],
  },

  {
    path: "promotion-marathi",
    component: PromotionMarathiComponent,
  },
  {
    path: "promotion-english",
    component: PromotionEnglishComponent,
  },
  {
    path: "catalogue/product-wishlist",
    component: CatalogueProductWishlistComponent,
    canActivate: [authGuard]
  },
  {
    path: "catalogue/company-wishlist",
    component: CatalogueCompanyWishlistComponent,
    canActivate: [authGuard]
  },
  {
    path: "contests/participants-list",
    component: ParticipantsListComponent,
  },
  {
    path: "contests/details/:participant_id",
    component: VideoDetailsComponent,
  },
  {
    path: "reg/payment-success",
    component: PaymentSuccessComponent,
    canActivate: [authGuard]
  },
  { path: 'auth/init', component: InitComponent },
  { path: 'auth/callback', component: CallbackComponent },
  { path: 'auth/link-login', component: LinkLoginComponent },
  { path: '**', redirectTo: '' }
];
